import { render, staticRenderFns } from "./order.vue?vue&type=template&id=21be4e70&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=21be4e70&prod&scoped=true&lang=less&"
import style1 from "./order.vue?vue&type=style&index=1&id=21be4e70&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be4e70",
  null
  
)

export default component.exports